import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
export const HeaderConfiguration = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  box-sizing: border-box;

  span {
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #ffffff;
  }
`;
export const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 57px;
  height: 57px;
  margin-left: 5px;
  border-radius: 50%;
  background: #c4c4c4;

  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;

  img {
    width: 57px;
    height: 57px;
    border-radius: 50%;
  }
`;
export const DetailsContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #949494;
    border-radius: 4px;
  }
`;
export const MenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  padding: 10px;
  border-bottom: 2px solid #a7a7a7;
`;
export const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.color ? props.color : "#00587A")};
  font-family: "Poppins" !important, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
`;
export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
  padding: 10px;

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #949494;
    border-radius: 4px;
  }
`;
export const DetailsContentItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 15px;
  color: #959595;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }
`;
export const DetailsContentItemInfo = styled.div`
  span {
    font-family: "Poppins" !important;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 21px;
    color: #4d4d4d;
  }
`;
export const DetailsTime = styled.span`
  margin-left: 50px;
  display: flex;
  flex-direction: column;

  span {
    color: #00587a;
    cursor: pointer;
  }
`;
export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90px;
  border-left: 5px solid #5abde7;

  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #949494;
    border-radius: 4px;
  }

  .ql-toolbar {
    display: none;
  }

  .ql-container {
    border: none;
    height: 90px;
  }
`;
export const Actions = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 43px;
  height: 43px;
  border-radius: 50%;
  cursor: pointer;
  right: 10px;
  bottom: 10px;
  background-color: #5bbde7;
  background: #5bbde7;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
`;
export const Toltip = styled.div`
  position: absolute;
  display: flex;
  align-items: center;

  top: 1px;
  left: 71px;

  background: ${(props) => (props.color ? props.color : "#C4C4C4")};
  border-radius: 20px;
  padding: 1px 4px;

  font-family: "Poppins" !important;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 15px;

  color: #ffffff;
`;
